var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "button button--primary",
      attrs: {
        href: _vm.checkoutURL,
        disabled: _vm.isDisabled || _vm.redirectInProgress,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.redirectToCheckout.apply(null, arguments)
        },
      },
    },
    [_c("span", [_vm._v(_vm._s(_vm.label))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }